module.exports = __webpack_public_path__ + "static/media/roaming-data.ebbc94aa.svg";